import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as SalesStyles from "../../styles/sales";

function Sales() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [sales, setSales] = useState([]);

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("3D Printing Service - Sales"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("3D Printing Service"));

        handleLoad();
    }, []);

    function handleLoad() {
        Axios.post("/pods/3dPrintingShop/loadSales")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setSales(data.sales);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleNewSale() {
        navigate("./new");
    }

    function handleSaleClick(uuid) {
        navigate(`./modify/${uuid}`);
    }

    return (
        <div style={SalesStyles.body}>
            <div style={SalesStyles.columnRight}>
                <Button onClick={handleNewSale}>New Sale</Button>
            </div>
            <br />
            {sales.map((sale, index) => {
                return (
                    <div key={index}>
                        <Card
                            style={sale.active == "true" ? SalesStyles.cardStyle : SalesStyles.deCardStyle}
                            onClick={handleSaleClick.bind(this, sale.uuid)}
                        >
                            <Card.Body>
                                <Row>
                                    <Col>{sale.title}</Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <br />
                    </div>
                );
            })}
        </div>
    );
}

export default Sales;
